/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';
import { UndoResultKind, UndoToastState, UndoToastTypes } from './types';

const INITIAL_STATE: UndoToastState = {
  payload: null,
  request: {
    loading: false,
    loaded: false,
    error: false,
  },
  result: null,
  lastUndo: null,
};

const kindForFailure = (status?: number): UndoResultKind => {
  if (status === 410) return 'expired';
  if (status === 404) return 'nothing';
  return 'error';
};

const reducer: Reducer<UndoToastState> = (state = INITIAL_STATE, action) =>
  produce(state, (draft) => {
    const { type, payload, result, undoType, restoredKey, total = 0 } = action;

    switch (type) {
      case UndoToastTypes.SHOW:
        draft.payload = payload;
        draft.request = { loading: false, loaded: false, error: false };
        draft.result = null;
        break;

      case UndoToastTypes.DISMISS:
        draft.payload = null;
        draft.request = { loading: false, loaded: false, error: false };
        draft.result = null;
        break;

      case UndoToastTypes.UNDO_REQUEST:
        draft.request = { loading: true, loaded: false, error: false };
        break;

      case UndoToastTypes.UNDO_SUCCESS: {
        if (!result) {
          draft.request = { loading: false, loaded: false, error: true };
          draft.result = { kind: 'error', restored: 0, total };
          break;
        }

        const restored = result.data?.[restoredKey]?.length ?? 0;
        let kind: UndoResultKind = 'restored';
        if (restored === 0) kind = 'nothing';
        else if (restored < total) kind = 'partial';

        draft.request = { loading: false, loaded: true, error: false };
        draft.result = { kind, restored, total };
        if (restored > 0) draft.lastUndo = { type: undoType, at: Date.now() };
        if (kind === 'restored') draft.payload = null;
        break;
      }

      case UndoToastTypes.UNDO_FAILURE:
        draft.request = { loading: false, loaded: false, error: true };
        draft.result = { kind: kindForFailure(result?.status), restored: 0, total };
        break;

      default:
        break;
    }
  });

export default reducer;
